export default "__VITE_ASSET__BVVUCknG__"